export var InputObjectType;
(function (InputObjectType) {
    InputObjectType[InputObjectType["String"] = 0] = "String";
    InputObjectType[InputObjectType["Boolean"] = 1] = "Boolean";
    InputObjectType[InputObjectType["Image"] = 2] = "Image";
    InputObjectType[InputObjectType["Date"] = 3] = "Date";
    InputObjectType[InputObjectType["Time"] = 4] = "Time";
})(InputObjectType || (InputObjectType = {}));
